





















 import { Component, Vue, Prop } from 'vue-property-decorator';
 import AgroIcons from "@/components/agroIcons/AgroIcons.vue"; 
 import Loading from "@/components/loading/Loading.vue";
 import { formattedLargerAreas } from '@/filters/area';

 @Component({
   name: 'AgroGenericCard',
   components: {
     Icon: AgroIcons,
     Loading, 
   },
   filters: {
    formattedLargerAreas,
  },
 })

export default class AgroGenericCard extends Vue {

    @Prop({ type: String, default: "" }) private title!: string;
    @Prop({ type: String, default: "" }) private icon!: string;
    @Prop({ type: String, default: "#00FCA1" }) private color!: string;
    @Prop({ type: Number, default: 0 }) private value!: number;
    @Prop({ type: String, default: "" }) private unit!: string;
    @Prop({ type: Boolean, default: false }) private isLoading!: boolean;
    @Prop({ type: Boolean, default: false }) private isCardArea!: boolean;

}
